import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AddTransaction } from "../card/AddTransaction";

export function AddTransactionModal() {
  const { t } = useTranslation();

  return (
    <Dialog
      maxWidth="lg"
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("searchCard.manageTxns.addTransaction")}
      </DialogTitle>
      <DialogContent>
        <AddTransaction />
      </DialogContent>
    </Dialog>
  );
}
